import React from "react";

const IconXSvg = ({ size = 16 }: { size?: number }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden
	>
		<path d="M4 4L8 8M8 8L12 12M8 8L12 4M8 8L4 12" />
	</svg>
);

export default IconXSvg;
